import React from 'react';
import { HashRouter, Route, Routes } from "react-router-dom";
import Preloader from './component/preloader/preloader';
import Main from './component/main/main';
import Blog from './component/blog/blog';
import './App.css';
import BlogContent from './component/blogContent/BlogContent';
import Running from './component/running/running';


function App() {

  return (
    <React.StrictMode>
      <HashRouter>
        <Routes>
          <Route path="/" element ={<Preloader />} />
          <Route path="/main" element ={<Main />} />
          <Route path='/blog' element = {<Blog />} />
           <Route path='/blogContent' element = {<BlogContent />} />
           <Route path='/running' element = {<Running />} />
        </Routes>
      </HashRouter>
    </React.StrictMode>
  );
}

export default App;
